import { render, staticRenderFns } from "./yifangDate.vue?vue&type=template&id=2c8521c2&scoped=true"
import script from "./yifangDate.vue?vue&type=script&lang=js"
export * from "./yifangDate.vue?vue&type=script&lang=js"
import style0 from "./yifangDate.vue?vue&type=style&index=0&id=2c8521c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8521c2",
  null
  
)

export default component.exports